<template>
  <div
    class="pl-12 md:pl-16 pb-4 lg:h-full bg-grey-1 overflow-y-auto scrollbar transition"
    :class="{ 'sidebar-closed': !categoriesOpen }"
  >
    <div class="flex flex-col justify-between p-x">
      <div class="flex-a justify-between h-12">
        <nav aria-label="Breadcrumb">
          <ol>
            <li class="inline">
              <RouterLink
                :to="{ name: 'home' }"
                class="focus-a"
                v-html="'Home / '"
              />
            </li>
            <li class="inline">
              <RouterLink
                :to="breadcrumb.path"
                class="focus-a"
                v-html="breadcrumb.title"
              />
            </li>
          </ol>
        </nav>

        <Button
          icon="ChevronIcon"
          type="button"
          iconsize="1.2rem"
          iconcolor="body"
          :aria="categoriesOpen ? 'Hide content' : 'Show Content'"
          :aria-expanded="categoriesOpen || false"
          aria-controls="content-panel"
          :iconrotation="categoriesOpen ? 'rotate-270' : 'rotate-90'"
          class="h-6"
          @buttonClick="sidebarOpen = !sidebarOpen"
        />
      </div>
    </div>
    <section
      id="content-panel"
      :aria-label="category.title"
      :aria-hidden="!categoriesOpen"
      class="transition"
      :class="{ hidden: !categoriesOpen }"
    >
      <Category v-if="!isSubjectList" :category="category" />
      <Subjects v-if="isSubjectList" :category="category" />
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Subjects from '@/components/Subjects.vue'
import Category from '@/components/Category.vue'
import Button from '@/components/buttons/Button.vue'

export default {
  name: 'Categories',

  components: {
    Subjects,
    Category,
    Button
  },

  props: {
    category: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      sidebarOpen: true
    }
  },

  computed: {
    ...mapState(['touch', 'mobile', 'categoriesOpen']),
    ...mapGetters(['categories']),

    isSubjectList() {
      return this.category.slug === 'subjects'
    },

    breadcrumb() {
      if (this.category.type === 'subject') {
        return {
          title: 'Subjects',
          path: { name: 'campus-category', params: { category_id: 'subjects' } }
        }
      } else {
        return {
          title: this.category.title,
          path: {
            name: 'campus-category',
            params: { category_id: this.category.slug }
          }
        }
      }
    }
  },

  watch: {
    sidebarOpen: {
      immediate: true,
      handler(value) {
        this.$store.commit('toggleCategoriesState', value)
      }
    }
  },

  created() {
    if (this.mobile) {
      this.sidebarOpen = false
    }
  }
}
</script>
